import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import loginReducer from './components/login/reducer';
import theodoreLoginReducer from './components/Theodore/login/reducer'
import signUpReducer from './Admin/Analyst/Create/reducer';
import forgotPasswordReducer from './components/forgot-password/reducer';
import forgotTheodorePasswordReducer from './components/Theodore/forgot-password/reducer'
import usersReducer from './Admin/user-management/all-users/reducer';
import creditLimitModelListReducer from './Admin/CreditLimit/View/reducer';
import creditLimitModelDataReducer from './Admin/CreditLimit/Edit/reducer';
import creditLimitModelAddReducer from './Admin/CreditLimit/Create/reducer';
import allDefaultProductReducer from './Admin/Corporate/DefaultProduct/reducer'
import newsFeedsReducer from './Analyst/News-Moderation/reducer';
import scorecardInitialValuesReducer from './Admin/Scorecard/Create/ScorecardForm/reducer';
import caseReducer from './Analyst/Cases/List/CaseReducer';
import dataListReducer from './Admin/Data-Upload/reducer'
import sectionReducer from './Analyst/Cases/View/SectionReducer';
import autoSuggestReducer from './components/ReusableComponents/AutoSuggest/reducer';
import riskGradesReducer from './Admin/Scorecard/Create/RiskGrades/reducer';
import createScorecardReducer from './Admin/Scorecard/Create/reducer';
import caseCreateReducer from './Analyst/Cases/Create/reducer'
import sectionTemplateFormReducer from './Admin/SectionTemplate/Create/reducer';
import sectionTemplateSearchReducer from './Admin/SectionTemplate/Search/reducer';
import sectionTemplateViewReducer from './Admin/SectionTemplate/View/reducer';
import sectionTemplateListReducer from './Admin/SectionTemplate/List/reducer';
import riskFactorReducer from './Admin/RiskFactor/reducer';
import scorecardReducer from './Admin/Scorecard/List/reducer';
import overriddingRiskFactorReducer from './Admin/RiskFactor/OverridingRiskFactor/reducer';
import automatedOverriddingRiskFactorReducer from './Admin/RiskFactor/AutomatedOverridingRiskFactor/reducer';
import riskFactorListReducer from './Admin/RiskFactor/List/reducer';
import corporateReducer from './Corporate/corporate/reducer';
import alertsReducer from './Corporate/Sidebar/reducer';
import portFolioReducer from './Corporate/my-portfolio/reducer';
import ceditUsageReducer from './Corporate/usage-stats/reducer';
import CorporateBulkCaseRequestReducer from './Corporate/bulk-case-request/reducer';
import corporateOnboardingCreateReducer from './Admin/Corporate/Create/reducer';//CorporateListReducer
import CorporateListReducer from './Admin/Corporate/List/reducer';
import CorporateBulkEndUserReducer from './Admin/Corporate/CreateBulkEndUser/reducer';
import MeteringStatsCorporateListReducer from './Admin/Corporate/MeteringStats/reducer';
import UsageStatsListReducer from './Corporate/usage-stats/usage-stats-dashboard/reducer'
import reportCorporateReducer from './Corporate/Credit-worthiness-dashboard/reducer';
import dashboardReducer from './Corporate/dashboard/reducer';
import adminDashboardReducer from './Admin/admin-dashboard/reducer';
import preloaderReducer from './components/UI/Preloader/reducer';
import correspondentListReducer from './Correspondent/Tasks/reducer';
import correspondentTaskReducer from './Correspondent/TaskDetails/reducer';
import correspondentBillingReducer from './Admin/Billing/reducer';
import correspondentOnboardingCreateReducer from './Admin/Correspondent-Onboarding/Create/reducer';
import CorrespondentListReducer from './Admin/Correspondent-Onboarding/List/reducer';
//import credenceReducer from './Admin/Credence/reducer';
import commonReducer from './components/Services/reducer';
import globalConfigurationReducer from './Admin/GlobalConfigurations/reducer';
import bulkCaseReducer from './Analyst/Cases/Bulk-Case/reducer';
import DIYReportReducer from './Admin/Corporate/DIYReportSetup/reducer';
import FetchKibanaConfigReducer from './Corporate/Kibana/reducer';
import commonComponentReducer from './Analyst/Cases/CommonComponent/reducer';
import changePasswordReducer from "./components/change-password/reducer" 
import quickReportReducer from './Analyst/Cases/Bulk-Case/QuickReportBulkCase/reducer';
import legalModerationReducer from './Analyst/Cases/View/LegalModeration/reducer';
import newsModerationReducer from './Analyst/Cases/View/NewsModeration/reducer';
import cugPortfolioReducer from './Corporate/my-portfolio/cug-portfolio/reducer';

import serverOnReducer from './Admin/admin-header/ServerOnModal/reducer';
import ratingCompanyMapReducer from './Analyst/Cases/RatingCompanyMap/reducer';
import monitoringDataReducer from './Corporate/my-portfolio/monitoring/reducer';
import counterpartySearchComponentReducer from './Admin/Counterparty/Search/reducer';
import ratingsDataUploadReducer from './Admin/Counterparty/RatingsDataUpload/reducer';
import allocatePartnerDataReducer from './Analyst/Cases/View/AllocatePartner/reducer';
import internationalReducer from './Admin/International/reducer'
import ewsReducer from './Admin/early-warning-system/reducer'
import additionalFieldsReducer from './Analyst/Cases/View/AllocatePartner/AdditionalFieldsForm/reducer'
import counterpartyDataReducer from './Admin/Counterparty/Search/EditCounterpartyForm/reducer'
import counterpartyMasterDataReducer from './Admin/Counterparty/Search/EditCounterpartyMasterDataForm/reducer'
import apiCasesExtractDownloadReducer from './Analyst/Cases/Api/reducer'
import vendorDataReducer from './Admin/Vendor-Tracker/reducer';
import misFormFieldReducer from './Admin/Mis-Form-Fields/reducer';
import automatedRevenueReducer from './Analyst/Cases/View/EditSection/AutomatedRevenueForm/reducer'
import automatedBenchmarkReducer from './Analyst/Cases/View/EditSection/AutomatedBenchmarkForm/reducer';
import creditLimitEditSectionReducer from './Analyst/Cases/View/EditSection/CreditLimitEditSection/reducer'
import KycUsageReducer from './Admin/KycUsage/reducer';
import MeteringSystemReducer from './Admin/Metering-System/reducer';
import CorporateCaseCountReducer from './Admin/Metering-System/CorprateCaseCount/reducer';
import EwsReportListReducer from './Corporate/my-portfolio/monitoring/ews-charts/ewsReport/reducer';
import homeReducer from './Corporate/Home/reducer';
import misTeamReducer from './Admin/Mis-Team/reducer';
import ifscMasterReducer from './Admin/IfscMaster/reducer';
import localPartyMasterReducer from './Admin/LocalPartyMaster/reducer';
import ifscUserMasterReducer from './Admin/IfscUserMaster/reducer';
import corporateBillingMasterReducer from './Admin/CorporateBillingMaster/reducer';
import corporateMasterReducer from './Admin/corporateMaster/reducer';
import activityLogExtractDownloadReducer from './Admin/ActivityLog/reducer';
import UserAccessManagementCorporateListReducer from './Admin/userAccessManagement/reducer';
import partnerCostReducer from './Admin/Partner-Cost/reducer';
import databaseCaseCreationComponentReducer from './Analyst/Cases/Database/reducer'
import countryIndustryReportsReducer from './Admin/Country-Industry-Reports/reducer';
import bulkCaseUpdationReducer from './Analyst/Cases/Bulk-Case-Updation/reducer';
import supportWorkAutomationReducer from './Admin/Support-Work-Automation/reducer';

    const appReducer = combineReducers({
        loginDetails: loginReducer,
        theodoreLoginReducer: theodoreLoginReducer,
        signUpDetails: signUpReducer,
        forgotPassword: forgotPasswordReducer,
        forgotTheodorePassword: forgotTheodorePasswordReducer,
        allUserList: usersReducer,

        creditLimitModelList:creditLimitModelListReducer,
        creditLimitModelData:creditLimitModelDataReducer,
        creditLimitModelResponse:creditLimitModelAddReducer,
        allDefaultProduct:allDefaultProductReducer,
        newsFeeds: newsFeedsReducer,
        alertsReducer: alertsReducer,
        scorecardInitialValues: scorecardInitialValuesReducer,
        form: formReducer,
        cases: caseReducer,
        section: sectionReducer,
        autoSuggest: autoSuggestReducer,
        riskGrades: riskGradesReducer,
        createScorecard: createScorecardReducer,
        sectionTemplate: sectionTemplateFormReducer,
        sectionTemplateSearch: sectionTemplateSearchReducer,
        sectionTemplateDetails: sectionTemplateViewReducer,
        sectionTemplateList: sectionTemplateListReducer,
        createCase: caseCreateReducer,
        scorecardReducer: scorecardReducer,
        overriddingRiskFactor: overriddingRiskFactorReducer,
        automatedOverriddingRiskFactor: automatedOverriddingRiskFactorReducer,
        riskFactorList: riskFactorListReducer,
        riskFactor: riskFactorReducer,
        corporate: corporateReducer,
        portfolio: portFolioReducer,
        ceditUsageReducer: ceditUsageReducer,
        CorporateBulkCaseRequestReducer: CorporateBulkCaseRequestReducer,
        reportCorporate: reportCorporateReducer,
        dashboard: dashboardReducer,
        adminDashboard: adminDashboardReducer,
        corporateOnBoardingCreate: corporateOnboardingCreateReducer,
        corporateListData: CorporateListReducer,
        meteringStatsCorporateListData:MeteringStatsCorporateListReducer,
        UsageStatsListData:UsageStatsListReducer,
        corporateBulkEndUserData: CorporateBulkEndUserReducer,
        preloaderReducer: preloaderReducer,
        correspondentListData: correspondentListReducer,
        correspondentTasks: correspondentTaskReducer,
        correspondentBilling: correspondentBillingReducer,
        correspondentOnboarding: correspondentOnboardingCreateReducer,
        correspondentAdminList: CorrespondentListReducer,
        //credenceReducer: credenceReducer,
        commonReducer: commonReducer,
        globalConfiguration: globalConfigurationReducer,
        bulkCase: bulkCaseReducer,
        DIYReportConfig: DIYReportReducer,
        FetchKibanaConfig: FetchKibanaConfigReducer,
        commonCaseComponentReducer: commonComponentReducer,
        changePassword : changePasswordReducer,
        quickReport : quickReportReducer,
        legalModeration : legalModerationReducer,
        newsModeration : newsModerationReducer,
        additionalLegalModeration : legalModerationReducer,
        // masterDataKey: masterDataKeyListReducer
        serverOn : serverOnReducer,
        ratingCompanyMap : ratingCompanyMapReducer,
        cugPortfolio : cugPortfolioReducer,
        monitoringData : monitoringDataReducer,
        counterpartySearchData: counterpartySearchComponentReducer,
        ratingsUploadData: ratingsDataUploadReducer,

        allocatePartnerData: allocatePartnerDataReducer,
        additionalFieldsInitialValuesReducer : additionalFieldsReducer,
        counterpartyDataInitialValuesReducer : counterpartyDataReducer,
        counterpartyMasterDataInitialValuesReducer : counterpartyMasterDataReducer,
        intl : internationalReducer,
        ews: ewsReducer,
        dataList:dataListReducer,
        apiCasesData:apiCasesExtractDownloadReducer,
        vendorData:vendorDataReducer,
        automatedRevenueData: automatedRevenueReducer,
        automatedBenchmarkData: automatedBenchmarkReducer,
        creditLimitEditSection:creditLimitEditSectionReducer,
        misFormField:misFormFieldReducer,
        sectionReducer: sectionReducer,
        kycUsageReducer: KycUsageReducer,
        MeteringSystemReducer: MeteringSystemReducer,
        //sectionReducer: sectionReducer,
        CorporateCaseCountReducer : CorporateCaseCountReducer,
        ewsReportListReducer:EwsReportListReducer,
        home: homeReducer,
        misTeamReducer:misTeamReducer,
        ifscMasterReducer : ifscMasterReducer,
        localPartyMasterReducer : localPartyMasterReducer,
        ifscUserMasterReducer : ifscUserMasterReducer,
        corporateBillingMasterReducer : corporateBillingMasterReducer,
        corporateMasterReducer : corporateMasterReducer,
        activityLogData: activityLogExtractDownloadReducer,
        userAccessManagementCorporateListData: UserAccessManagementCorporateListReducer,
        partnerCostReducer: partnerCostReducer,
        databaseCaseCreationData: databaseCaseCreationComponentReducer,
        countryIndustryReports: countryIndustryReportsReducer,
        bulkCaseUpdation: bulkCaseUpdationReducer,
        supportWorkAutomation: supportWorkAutomationReducer,
    });

const createReducer = (state, action) => {
    // when a logout action is dispatched it will reset redux state
    if (action.type === 'LOGOUT') {
      state = undefined;
    }
  
    return appReducer(state, action);
};

export default createReducer;